import * as React from 'react';

import {colors} from '../colors/colors';
import {HoverPopover} from '../hover-popover/hover-popover';
import {WarningIcon} from '../icon/svg/warning-icon';

type Props = {
    popoverContent: React.ReactNode;
};

export function WarningWithPopover(props: Props) {
    const anchor = React.useRef(null);

    return (
        <>
            <div ref={anchor} className='pointer-cursor'>
                {/* @ts-expect-error */}
                <WarningIcon size={12} color={colors.yellow} />
            </div>
            {/* @ts-expect-error */}
            <HoverPopover anchorRef={anchor} location='top'>
                {props.popoverContent}
            </HoverPopover>
        </>
    );
}
